module.exports = __webpack_public_path__ + "static/media/xmg_2_filter.bfb73ee5.png";